/* ============================================================
   Mybibblio — visual effects layer (pure presentation)
   • Scroll-reveal: sections/cards fade+rise in with stagger
   • Hero magic: drifting gold star sparkles (Ken Burns is CSS)
   • Story cards: subtle 3D tilt toward the cursor (desktop)
   All effects respect prefers-reduced-motion and change nothing
   functional — safe to remove at any time.
   ============================================================ */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('kb-fx');

  // ---- Scroll reveals -------------------------------------------------
  var REVEAL = [
    '.kb-head', '.kb-story', '.kb-how__step', '.kb-tms__card', '.kb-why__item',
    '.kb-art__card', '.kb-faq__item', '.kb-trust__item', '.kb-gift__occasions',
    '.kb-look__cover', '.kb-look__spreads', '.kb-look__copy',
    '.kb-spot__media', '.kb-spot__copy', '.kb-quote__inner', '.kb-hero2__steps',
    'main[data-template="collection"] .product-grid__item'
  ].join(',');

  function initReveals() {
    var els = document.querySelectorAll(REVEAL);
    if (!els.length || !('IntersectionObserver' in window)) return;
    // stagger siblings that share a parent
    var counts = new WeakMap();
    els.forEach(function (el) {
      if (el.closest('.kb-hero')) return;            // never touch the hero (LCP)
      var p = el.parentNode || document.body;
      var n = counts.get(p) || 0;
      counts.set(p, n + 1);
      el.style.setProperty('--kb-rvd', Math.min(n * 55, 240) + 'ms');
      el.classList.add('kb-rv');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -4% 0px', threshold: 0.05 });
    document.querySelectorAll('.kb-rv').forEach(function (el) { io.observe(el); });
  }

  // ---- Hero sparkles --------------------------------------------------
  function initSparkles() {
    var hero = document.querySelector('.kb-hero, .kb-hero2');
    if (!hero || hero.querySelector('.kb-spark')) return;
    for (var i = 0; i < 7; i++) {
      var s = document.createElement('span');
      s.className = 'kb-spark';
      s.textContent = '✦';
      s.setAttribute('aria-hidden', 'true');
      s.style.left = (6 + Math.random() * 88) + '%';
      s.style.top = (8 + Math.random() * 70) + '%';
      s.style.fontSize = (10 + Math.random() * 14) + 'px';
      s.style.animationDelay = (Math.random() * 6).toFixed(2) + 's';
      s.style.animationDuration = (4.5 + Math.random() * 4).toFixed(2) + 's';
      hero.appendChild(s);
    }
  }

  // ---- Story card tilt (desktop pointers only) ------------------------
  function initTilt() {
    if (!window.matchMedia('(pointer: fine)').matches) return;
    document.querySelectorAll('.kb-story__media').forEach(function (media) {
      if (media.dataset.kbTilt === '1') return;
      media.dataset.kbTilt = '1';
      media.addEventListener('pointermove', function (e) {
        var r = media.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        media.style.transform = 'perspective(900px) rotateY(' + (x * 6).toFixed(2) + 'deg) rotateX(' + (-y * 5).toFixed(2) + 'deg)';
      });
      media.addEventListener('pointerleave', function () {
        media.style.transform = '';
      });
    });
  }

  // ---- Story characters --------------------------------------------
  // Two kinds: 'free' = transparent cutouts that genuinely roam (fly across,
  // drive through, or peek-and-bob), and 'bubble' = characters whose art
  // lives in a painted scene, shown as soft feathered story-bubbles.
  var CHARS = [
    // --- Homepage: travelling ---
    { img: 'kb-fc-skybeast.png',  mode: 'fly',   sel: '.kb-stories',       idx: 0, css: 'top:3%;    --chr-s:clamp(82px,10vw,138px); --chr-fly:60s; --chr-d:6s;' },
    { img: 'kb-fc-clockwork.png',  mode: 'fly',   sel: '.kb-why__grid',     idx: 0, css: 'top:6%;    --chr-s:clamp(82px,10vw,138px); --chr-fly:76s; --chr-d:7s;' },
    // --- Homepage: peeks (incl. the mouse peeking over his own Rainbow Rescue Parade book) ---
    { img: 'kb-fc-mouse.png',      mode: 'peekself', sel: '.kb-stories__grid .kb-story', idx: 1, css: 'top:-30px; right:-14px; --chr-s:clamp(70px,8vw,104px); --chr-d:4.6s;' },
    { img: 'kb-fc-sprite.png',     mode: 'peek',  sel: '.kb-tf',            idx: 0, css: 'top:5%; right:2.5%; --chr-s:clamp(72px,8vw,112px); --chr-d:5.6s;', par: -0.045 },
    { img: 'kb-fc-ledger.png',     mode: 'peek',  sel: '.kb-look',          idx: 0, css: 'top:6%; right:2%; --chr-s:clamp(90px,11vw,152px); --chr-d:7.4s;', par: -0.05 },
    { img: 'kb-fc-clockwork.png',  mode: 'peek',  sel: '.kb-how__grid',     idx: 0, css: 'top:-40px; right:1.5%; --chr-s:clamp(88px,11vw,148px); --chr-d:7s;', par: 0.05 },
    { img: 'kb-fc-sprite.png',     mode: 'peek',  sel: '.kb-tms__grid',     idx: 0, css: 'top:-50px; right:3%; --chr-s:clamp(80px,10vw,132px); --chr-d:5.8s;', par: -0.05 },
    // --- Homepage: story-bubbles (feathered painted cameos) ---
    { img: 'kb-chr-cusp.jpg',      mode: 'bubble',sel: '.kb-spot',          idx: 0, css: 'bottom:4%; right:2.5%; --chr-s:clamp(118px,15vw,205px); --chr-d:8.5s;', par: -0.06 },
    { img: 'kb-chr-pocket.jpg',    mode: 'bubble',sel: '.kb-spot',          idx: 1, css: 'bottom:-26px; right:15%; --chr-s:clamp(88px,10vw,140px); --chr-d:7s;', par: 0.05 },
    { img: 'kb-bub-sprite.jpg',    mode: 'bubble',sel: '.kb-art',           idx: 0, css: 'top:7%; left:2.5%; --chr-s:clamp(96px,12vw,160px); --chr-d:6.4s;', par: 0.05 },
    { img: 'kb-bub-sprite.jpg',    mode: 'bubble',sel: '.kb-makebook',      idx: 0, css: 'top:8%; right:3%; --chr-s:clamp(88px,11vw,142px); --chr-d:6.9s;', par: -0.05 },
    // --- Shop page ---
    { img: 'kb-fc-skybeast.png',   mode: 'margin',sel: '.product-grid-container', idx: 0, css: 'top:9%;  left:5%;  --chr-s:clamp(88px,7.5vw,132px); --chr-d:6.2s;', par: 0.05 },
    { img: 'kb-fc-ledger.png',     mode: 'margin',sel: '.product-grid-container', idx: 0, css: 'top:52%; right:6%; --chr-s:clamp(92px,7.5vw,142px); --chr-d:7.3s;', par: -0.05 }
  ];
  var CHR_BASE = null;
  function chrUrl(file) { return CHR_BASE ? CHR_BASE + file : null; }
  function initCharacters() {
    var probe = document.querySelector('script[src*="mybibblio-fx"]');
    if (!probe) return;
    CHR_BASE = probe.getAttribute('src').replace(/\?.*$/, '').replace(/[^\/]*$/, '');
    var tracked = [];
    CHARS.forEach(function (c) {
      var target = document.querySelectorAll(c.sel)[c.idx];
      if (!target) return;
      var section = (c.mode === 'peekself') ? target : (target.closest('.kb-section') || target);
      if (getComputedStyle(section).position === 'static') section.style.position = 'relative';
      var wrap = document.createElement('span');
      wrap.className = 'kb-chr-wrap kb-chr-wrap--' + c.mode;
      wrap.style.cssText = c.css;
      var img = document.createElement('img');
      img.className = (c.mode === 'bubble') ? 'kb-chr' : 'kb-chr kb-chr--free';
      img.src = chrUrl(c.img);
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.loading = 'lazy';
      wrap.appendChild(img);
      section.appendChild(wrap);
      if (c.mode === 'peek' || c.mode === 'peekself' || c.mode === 'bubble' || c.mode === 'margin') tracked.push({ el: wrap, section: section, mode: c.mode, par: (c.mode === 'peekself' ? 0 : (c.par || 0.05)) });
      if (c.mode === 'drive') tracked.push({ el: wrap, section: section, mode: 'drive' });
    });
    if (!tracked.length) return;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var vh = window.innerHeight;
        tracked.forEach(function (o) {
          var r = o.section.getBoundingClientRect();
          if (r.bottom < -300 || r.top > vh + 300) return;
          if (o.mode === 'drive') {
            // hedgehog races across as you scroll through the section
            var p = (vh - r.top) / (vh + r.height);
            p = Math.max(0, Math.min(1, p));
            var w = o.el.offsetWidth || 140;
            o.el.style.transform = 'translateX(' + (p * (r.width - w)).toFixed(1) + 'px)';
          } else {
            var progress = (r.top + r.height / 2 - vh / 2);
            o.el.style.transform = 'translateY(' + (progress * o.par).toFixed(1) + 'px)';
          }
        });
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---- Hedgehog racer: scroll-triggered drive across the FAQ, dropping
  //      fading tyre marks, exiting off the right edge of the page. -------
  function initHedgehog() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var probe = document.querySelector('script[src*="mybibblio-fx"]');
    if (!probe) return;
    var base = probe.getAttribute('src').replace(/\?.*$/, '').replace(/[^\/]*$/, '');
    var mounts = [];
    var faq = document.querySelector('.kb-faq__list'); if (faq) mounts.push({ el: faq.closest('.kb-section') || faq, kind: 'faq' });
    var shop = document.querySelector('.product-grid-container'); if (shop) mounts.push({ el: shop, kind: 'shop' });
    mounts.forEach(function (m) {
      var section = m.el;
      if (getComputedStyle(section).position === 'static') section.style.position = 'relative';
      var lane = document.createElement('div'); lane.className = 'kb-hog-lane kb-hog-lane--' + m.kind;
      var mover = document.createElement('div'); mover.className = 'kb-hog-move';   // JS drives this (translateX)
      var hog = document.createElement('img'); hog.className = 'kb-hog'; hog.src = base + 'kb-fc-hedgehog.png';  // CSS does the vroom bob
      hog.alt = ''; hog.setAttribute('aria-hidden', 'true');
      mover.appendChild(hog); lane.appendChild(mover); section.appendChild(lane);
      var running = false;
      function park() { var size = hog.offsetWidth || 120; mover.style.transform = 'translateX(' + (-size - 60) + 'px)'; }
      park();
      function race() {
        if (running) return; running = true;
        var w = section.offsetWidth, size = hog.offsetWidth || 120;
        var startX = -size - 40, endX = w + size + 40, dur = 4600, t0 = null, lastMark = 0;
        function frame(ts) {
          if (t0 === null) t0 = ts;
          var pr = Math.min(1, (ts - t0) / dur);
          var x = startX + (endX - startX) * pr;
          mover.style.transform = 'translateX(' + x.toFixed(1) + 'px)';
          if (ts - lastMark > 80 && pr > 0.03 && pr < 0.97) {
            lastMark = ts;
            var mk = document.createElement('span'); mk.className = 'kb-tyre'; mk.style.left = (x + size * 0.3) + 'px';
            lane.appendChild(mk);
            (function (el) { setTimeout(function () { el.remove(); }, 1500); })(mk);
          }
          if (pr < 1) requestAnimationFrame(frame); else { running = false; park(); }
        }
        requestAnimationFrame(frame);
      }
      // drive when the section scrolls into view, then on a gentle loop
      var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) setTimeout(race, 500); }, { threshold: 0.2 });
      io.observe(section);
      setInterval(function () {
        var r = section.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.9 && r.bottom > 0) race();
      }, 11000);
    });
  }

  // ---- Ambient decor: clouds + a rainbow in empty space (tasteful, sparse) ----
  function initDecor() {
    var DECOR = [
      { cls: 'kb-rainbow', sel: '.kb-hero2', idx: 0, css: 'top:5%; right:2.5%; width:clamp(150px,17vw,300px); aspect-ratio:300/165; opacity:.42;', mobileHide: true },
      { cls: 'kb-cloud',   sel: '.kb-hero2', idx: 0, css: 'top:11%; left:4%; width:clamp(96px,11vw,175px); aspect-ratio:220/120;' },
      { cls: 'kb-cloud',   sel: '.kb-hero2', idx: 0, css: 'top:26%; right:4.5%; width:clamp(82px,9vw,145px); aspect-ratio:220/120; animation-duration:13s;', mobileHide: true },
      { cls: 'kb-cloud',   sel: '.kb-why__grid', idx: 0, css: 'top:-7%; right:4%; width:clamp(92px,11vw,165px); aspect-ratio:220/120; animation-duration:12s;' },
      { cls: 'kb-cloud',   sel: '.product-grid-container', idx: 0, css: 'bottom:64px; left:1.5%; width:clamp(90px,9vw,150px); aspect-ratio:220/120; animation-duration:11s;', mobileHide: true }
    ];
    DECOR.forEach(function (d) {
      var target = document.querySelectorAll(d.sel)[d.idx];
      if (!target) return;
      var section = target.closest('.kb-section') || target;
      if (getComputedStyle(section).position === 'static') section.style.position = 'relative';
      var el = document.createElement('span');
      el.className = 'kb-decor ' + d.cls + (d.mobileHide ? ' kb-hide-mobile' : '');
      el.style.cssText = d.css;
      el.setAttribute('aria-hidden', 'true');
      section.insertBefore(el, section.firstChild);
    });
  }

  function start() { initReveals(); initSparkles(); initTilt(); initCharacters(); initHedgehog(); initDecor(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
